import { kebabCase } from '@makemydeal/dr-common-utils';
import { formatMileageCharge } from '../../utils/formatUtils';
import { EXCESS_MILEAGE_CHARGE } from '../../constants';
import { TextInput } from '@interstate/components/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { dealLockHooks } from '../../hooks';
import { useFieldOverrideIndicator } from '../../hooks/useFieldOverrideIndicator';
import { usePaymentCall } from '../../utils/usePaymentCall';
import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';

const MILEAGE_CHARGE_OVERRIDE_INDICATOR_TEST_ID = 'mileage-charge-override-indicator';

const ExcessMileageChargeField = () => {
    const isUserProgramQuotes = useSelector(offerReduxSelectors.getIsUserProgramQuotes);
    const dispatch = useDispatch();
    const isLocked = dealLockHooks.useIsDealLocked();
    // Program-quotes has no slot for this charge and no middleware moves the edit to user-program-quotes,
    // so an edit there would be dropped without an error.
    const isDisabled = !isUserProgramQuotes || isLocked;

    const {
        enabled: overrideIndicatorEnabled,
        show: showOverrideIndicator,
        message: overrideMessage,
        recordManualOverride
    } = useFieldOverrideIndicator('mileageCharge');

    const { handleBlur, handleChange, value, handleKeyDown } = usePaymentCall(
        offerSelectors.getMileageChargeOverrideWithFallback,
        offerReduxActionCreators.updateMileageChargeOverride,
        { formatValueToString: formatMileageCharge, onUserEdit: recordManualOverride }
    );
    return (
        <FieldOverrideIndicator
            enabled={overrideIndicatorEnabled}
            show={showOverrideIndicator}
            message={overrideMessage}
            testId={MILEAGE_CHARGE_OVERRIDE_INDICATOR_TEST_ID}
        >
            <TextInput
                label={EXCESS_MILEAGE_CHARGE}
                name={kebabCase(EXCESS_MILEAGE_CHARGE)}
                onChange={handleChange}
                onBlur={(e) => {
                    dispatch(interactionAnalyticsActionCreators.costPerMileTextInput());
                    handleBlur(e);
                }}
                disabled={isDisabled}
                value={value}
                data-testid={kebabCase(EXCESS_MILEAGE_CHARGE)}
                size="sm"
                onKeyDown={handleKeyDown}
            />
        </FieldOverrideIndicator>
    );
};

export default ExcessMileageChargeField;
